import { globalCss } from '@leagueplatform/genesis-core';
import { createGlobalStyle } from 'styled-components';

export const LegacyGlobalStyles = createGlobalStyle`
  /* set up some default to use rem */
  html {
    /* to make 1rem = 10px for easier calculation */
    font-size: 62.5%;
  }

  body {
    font-size: 1.6rem;
  }

  * {
    box-sizing: border-box;
  }

  h1 {
    margin: 2.4rem 0;
  }

  h2 {
    margin: 2rem 0;
  }

  h3 {
    margin: 1.4rem 0;
  }

  h4,
  h5,
  h6 {
    margin: 1.2rem 0;
  }

  strong,
  a {
    font-weight: 500;
  }

  p {
    margin: 1rem 0;
    line-height: 1.6;
  }

  .genesis {
    margin: 0;
  }
`;

// Couldn't use `createGlobalStyle` here because it doesn't support `@layer`
export const scopedLegacyGlobalStyles = globalCss({
  '@layer base': {
    '.league-legacy-global-styles': {
      html: {
        fontSize: '62.5%',
      },
      body: {
        fontSize: '1.6rem',
      },
      '*': {
        boxSizing: 'border-box',
      },
      h1: {
        margin: '2.4rem 0',
      },
      h2: {
        margin: '2rem 0',
      },
      h3: {
        margin: '1.4rem 0',
      },
      'h4, h5, h6': {
        margin: '1.2rem 0',
      },
      'strong, a': {
        fontWeight: 500,
      },
      p: {
        margin: '1rem 0',
        lineHeight: 1.6,
      },
      '.genesis': {
        margin: 0,
      },
    },
  },
});
